import React from 'react';
import { Link } from 'react-router-dom';
import './css/NotFound.css';

function NotFound() {
  return (
    <div className="containerW">
      <div className="content not_found_w">
        <h1 className="bm_text_30 mb_10">Страница не найдена</h1>
        <Link to="/" className="not_found_link">
          На главную
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
